<template>
  <div id="history_detail">
    <div>
      <section>
        <h3>注文情報</h3>
        <div v-if="orderData">
          <div class="input_confirm5">
            <ul>
              <li>
                <span>注文番号</span>
                <span>{{orderData.orderNo}}</span>
              </li>
              <li>
                <span>ご注文日時</span>
                <span>{{getDate(orderData.planData.planOrderDate)}}</span>
                <span colspan="1" class="center" v-if="!isBeforeDate && !resrchFlag">
                  <button type="submit" class="main_btn sel_main_btn" @click="estimate(orderData.orderNo)">見積り書</button>
                </span>
              </li>
              <li>
                <span>ご請求金額</span>
                <span v-if="!resrchFlag">{{formatPrice(orderPrice.totalPrice)}}</span>
                <span v-else>{{formatPrice(priceData.resrchTotalPrice)}}</span>
              </li>
              <li>
                <span>決済方法</span>
                <span>{{paymentType}}</span>
              </li>
              <li>
                <span>施主名</span>
                <span>{{orderData.planData.planDeliveryName}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="estimation" v-if="!isBeforeDate && !resrchFlag">
        <h3>ご請求金額</h3>
        <dd-order-price
          :orderPrice="orderPrice"
          :isConstruct="isConstruct"
        />
      </section>
      <section class="estimation" v-if="resrchFlag">
        <h3>ご請求金額</h3>
        <dd-research-price
          :priceData="priceData"
        />
      </section>
      <section v-if="orderData.planEc.ecSnapPersonUserId">
        <h3>担当者情報</h3>
        <div>
          <div class="input_confirm3">
            <ul>
              <li>
                <span>店舗名</span>
                <span>{{orderData.planEc.ecSnapPersonOfficeName}}</span>
              </li>
              <li>
                <span>担当者名</span>
                <span>{{orderData.planEc.ecSnapPersonUserLastName}} {{orderData.planEc.ecSnapPersonUserFirstName}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section v-if="!resrchFlag">
        <h3>納品先情報</h3>
        <div v-if="orderData">
          <div class="input_confirm3">
            <ul>
              <li>
                <span>納品先名</span>
                <span>{{orderData.planData.planDeliveryBuilding}}</span>
              </li>
              <li>
                <span>納品先郵便番号</span>
                <span>{{orderData.planData.planDeliveryPostcd}}</span>
              </li>
              <li>
                <span>納品先住所</span>
                <span>{{deliAddress}}</span>
              </li>
              <li>
                <span>受取人氏名</span>
                <span>{{deliFullName}}</span>
              </li>
              <li>
                <span>受取人氏名（カナ）</span>
                <span>{{deliFullNameKana}}</span>
              </li>
              <li>
                <span>受取人電話番号</span>
                <span>{{orderData.planData.planDeliveryTel}}</span>
              </li>
              <li>
                <span>希望納品日</span>
                <span>{{getDateTime(orderData.planEc.ecInfoDeliPref1, orderData.planEc.ecInfoDeliPref1StTime, orderData.planEc.ecInfoDeliPref1EndTime)}}</span>
              </li>
              <li>
                <span>配送時の連絡事項</span>
                <span>{{orderData.planData.planDeliverryNotice}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section v-if="isConstruct && !resrchFlag">
        <h3>組立設置入力情報</h3>
        <div v-if="orderData">
          <div class="input_confirm3">
            <ul>
              <li>
                <span>組立先郵便番号</span>
                <span>{{orderData.planData.planStructPostcd}}</span>
              </li>
              <li>
                <span>組立先住所</span>
                <span>{{structAddress}}</span>
              </li>
              <li>
                <span>受取人氏名</span>
                <span>{{structFullName}}</span>
              </li>
              <li>
                <span>受取人氏名（カナ）</span>
                <span>{{structFullNameKana}}</span>
              </li>
              <li>
                <span>受取人電話番号</span>
                <span>{{orderData.planData.planStructTel}}</span>
              </li>
              <li>
                <span>第一希望納品日</span>
                <span>{{getDate(orderData.planEc.ecInfoBtPref1)}}</span>
              </li>
              <li>
                <span>第二希望納品日</span>
                <span>{{getDate(orderData.planEc.ecInfoBtPref2)}}</span>
              </li>
              <li>
                <span>第三希望納品日</span>
                <span>{{getDate(orderData.planEc.ecInfoBtPref3)}}</span>
              </li>
              <li>
                <span>配送時の連絡事項</span>
                <span>{{orderData.planData.planStructMessage}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section v-if="resrchFlag">
        <h3>事前現場調査情報</h3>
        <div v-if="orderData">
          <div class="input_confirm3">
            <ul>
              <li>
                <span>施主名（物件名）</span>
                <span>{{orderData.planData.planDeliveryName}}</span>
              </li>
              <li>
                <span>調査物件名</span>
                <span>{{orderData.planData.planDeliveryBuilding}}</span>
              </li>
              <li>
                <span>郵便番号</span>
                <span>{{orderData.planData.planDeliveryPostcd}}</span>
              </li>
              <li>
                <span>住所</span>
                <span>{{deliAddress}}</span>
              </li>
              <li>
                <span>立会人氏名</span>
                <span>{{deliFullName}}</span>
              </li>
              <li>
                <span>立会人氏名（カナ）</span>
                <span>{{deliFullNameKana}}</span>
              </li>
              <li>
                <span>立会人電話番号</span>
                <span>{{orderData.planData.planDeliveryTel}}</span>
              </li>
              <li>
                <span>立会人への直接連絡：</span>
                <span>{{resrchData.contactFlag ? 'あり' : 'なし'}}</span>
              </li>
              <li>
                <span>事前調査日</span>
                <span>{{getDateTime(resrchData.resrchPref1, resrchData.resrchPref1StartTime, resrchData.resrchPref1EndTime)}}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section>
        <div class="title">
          <h3>注文した商品</h3>
        </div>
        <div v-for="(cart,index) in orderDataList" :key="'cart-' + index">
          <dd-cart-item
            :cartData="cart"
            :type="'history'"
            :odMgId="cart.code"
            :isBeforeDate="isBeforeDate"
            :resrchFlag="resrchFlag"
            :resrchPriceData="priceData"
            @onShowEstimateModal="onShowEstimateModal"
          />
        </div>
      </section>
      <div class="control_btn_area">
        <button type="submit" class="main_btn cancel_btn" @click="cancel()">戻る</button>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {DC_URL, DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import * as AppEc from '../../utils/AppEc'
import CartItem from '../common/DcCartItem'
import OrderPrice from '../payment/DcOrderPrice'
import OrderResearch from '../payment/DcOrderResrch'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-cart-item': CartItem,
    'dd-order-price': OrderPrice,
    'dd-research-price': OrderResearch,
    'dd-loading-modal': LoadingModal
  },
  props: {
    orderNo: String
  },
  data () {
    return {
      orderPrice: {},
      priceData: {},
      resrchFlag: false,
      orderDataList: [],
      totalPrice: 0,
      isBeforeDate: false,
      userInfo: {}
    }
  },
  computed: {
    orderData: function () {
      return this.orderDataList[0]
    },
    deliFullName: function () {
      let name = (this.orderData.planData.planDeliverryLastName ? this.orderData.planData.planDeliverryLastName : '') +
        (this.orderData.planData.planDeliverryFirstName ? this.orderData.planData.planDeliverryFirstName : '')
      return name
    },
    deliFullNameKana: function () {
      let name = (this.orderData.planData.planDeliverryLastNameKana ? this.orderData.planData.planDeliverryLastNameKana : '') +
        (this.orderData.planData.planDeliverryFirstNameKana ? this.orderData.planData.planDeliverryFirstNameKana : '')
      return name
    },
    deliAddress: function () {
      let address = (this.orderData.planData.planDeliveryState ? this.orderData.planData.planDeliveryState : '') +
        (this.orderData.planData.planDeliveryCity ? this.orderData.planData.planDeliveryCity : '') +
        (this.orderData.planData.planDeliveryStreet ? this.orderData.planData.planDeliveryStreet : '')
      return address
    },
    structFullName: function () {
      let name = (this.orderData.planData.planStructLastName ? this.orderData.planData.planStructLastName : '') +
        (this.orderData.planData.planStructFirstName ? this.orderData.planData.planStructFirstName : '')
      return name
    },
    structFullNameKana: function () {
      let name = (this.orderData.planData.planStructLastNameKana ? this.orderData.planData.planStructLastNameKana : '') +
        (this.orderData.planData.planStructFirstNameKana ? this.orderData.planData.planStructFirstNameKana : '')
      return name
    },
    structAddress: function () {
      let address = (this.orderData.planData.planStructState ? this.orderData.planData.planStructState : '') +
        (this.orderData.planData.planStructCity ? this.orderData.planData.planStructCity : '') +
        (this.orderData.planData.planStructStreet ? this.orderData.planData.planStructStreet : '')
      return address
    },
    paymentType: function () {
      if (this.orderData.planEc.ecInfoPayType === 1) {
        return 'クレジットカード'
      } else if (this.orderData.planEc.ecInfoPayType === 2) {
        return '銀行振込'
      } else if (this.orderData.planEc.ecInfoPayType === 3) {
        return '掛け払い'
      }
      return ''
    },
    isConstruct: function () {
      let f = this.orderDataList.filter(d => d.planEc.ecInfoOpExFlag === true)
      return f.length > 0
    }
  },
  methods: {
    getDate: function (date) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      return time
    },
    getDateTime: function (date, start, end) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      if (!start || !end) {
        time += ' 時間指定なし'
      } else {
        time += start < 12 ? ' AM ' : ' PM '
        time += start + ':00'
        time += '～'
        time += end + ':00'
      }
      return time
    },
    getDetailData: function (orderNo) {
      let payload = {
        params: {
          orderNo: orderNo
        }
      }
      axios.get(DC_URL.ORDER + '/history/detail', payload)
        .then(response => {
          this.orderDataList = response.data.data.orderList
          this.orderPrice = response.data.data.orderPrice
          this.priceData = Object.assign({}, response.data.data.priceData)
          this.resrchFlag = response.data.data.resrchFlag
          this.isBeforeDate = response.data.data.isBeforeDate
          this.resrchData = response.data.data.resrchData
        }).catch(error => {
          Api.handleError(error)
        })
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
          document.body.style.overflow = 'scroll'
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
          document.body.style.overflow = 'hidden'
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        targetPlan: estimateData.targetPlan,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        makerData: estimateData.makerData,
        isProductData: !this.isBeforeDate,
        resrchFlag: this.resrchFlag,
        isNetPrice: this.isHaseko
      }
      AppEc.showEstimateModal(modalData)
    },
    cancel: function () {
      this.$router.go(-1)
    },
    estimate: function (orderNo) {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'GET',
        url: DC_URL.CART + '/estimate-history',
        responseType: 'blob',
        params: {
          orderNo: orderNo
        }
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          var pdf = response.data
          let blob = new Blob([pdf], {type: 'application/xlsx;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, '見積り書.xlsx')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = '見積り書.xlsx'
            link.click()
          }
          this.$refs.loadingModalRef.showModal(false)
        }
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    isHaseko: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    }
  },
  mounted: function () {
    console.log('orderNo detail' + this.orderNo)
    this.getDetailData(this.orderNo)
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/mypage/DcHistoryDetail.vue